import { Close as CloseIcon } from "@mui/icons-material";
import {
  IconButton,
  ListItemText,
  ListItemButton,
  ListItemIcon,
  Checkbox,
  Stack,
  Typography,
  Modal,
  Box
} from "@mui/material";
import { BIBlue } from "../../assets/helpers.jsx";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback.jsx";

const FilterOptions = (props) => {
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.BuySell || {};
  const {
    TEXT_FILTER_TITLE = English.BuySell.TEXT_FILTER_TITLE,
    TEXT_FILTER_SUBTITLE = English.BuySell.TEXT_FILTER_SUBTITLE,
    TEXT_FOR_SALE = English.BuySell.TEXT_FOR_SALE,
    TEXT_FOR_TRADE_BADGE = English.BuySell.TEXT_FOR_TRADE_BADGE
  } = LanguageData;
  return (
    <Modal open={props?.open} onClose={() => props?.onClose()}>
      <Box
        className="user-modal-responsive"
        sx={{
          borderRadius: "20px",
          p: 3,
          bgcolor: "white",
          maxWidth: "400px !important",
          outline: "none"
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700 }}>{TEXT_FILTER_TITLE}</Typography>
          <IconButton onClick={() => props?.onClose()} size="small">
            <CloseIcon />
          </IconButton>
        </Box>

        <Typography variant="body2" sx={{ mb: 2,  color: "text.secondary" }} >
          {TEXT_FILTER_SUBTITLE}
        </Typography>

        <Stack spacing={1}>
          {[
            { label: TEXT_FOR_SALE, key: "forSale" },
            { label: TEXT_FOR_TRADE_BADGE, key: "forTrade" }
          ].map(({ label, key }) => (
            <ListItemButton
              key={key}
              onClick={() =>
                props?.setFilterValues({
                  ...props?.filterValues,
                  [key]: !props?.filterValues?.[key]
                })
              }
              sx={{
                borderRadius: "12px",
                py: 1.5,
                bgcolor: props?.filterValues?.[key] ? "#eff6ff" : "transparent",
                "&:hover": { bgcolor: props?.filterValues?.[key] ? "#dbeafe" : "#f8fafc" }
              }}
            >
              <ListItemIcon sx={{ minWidth: 40 }}>
                <Checkbox
                  sx={{ color: BIBlue, p: 0 }}
                  checked={props?.filterValues?.[key]}
                  disableRipple
                />
              </ListItemIcon>
              <ListItemText
                primary={label}
                primaryTypographyProps={{ fontWeight: props?.filterValues?.[key] ? 600 : 400 }}
              />
            </ListItemButton>
          ))}
        </Stack>
      </Box>
    </Modal>
  );
};

export default FilterOptions;
